// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';

const DemoRentalHistoryPinCriteria = props =>
    <div className='demo-rental-pin-criteria'>
        <LabeledCriteria
            className='pin-criteria'
            isRequired={false}
            label='PIN'
            maxLength='17'
            onInputChange={props.onPinChange}
            placeholder='PIN'
            type='text'
            value={props.pin}
        />
    </div>;

DemoRentalHistoryPinCriteria.displayName = 'DemoRentalHistoryPinCriteria';
DemoRentalHistoryPinCriteria.propTypes = {
    onPinChange: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired
};

export default DemoRentalHistoryPinCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-pin-criteria.js